import React from 'react';
import { Clock, Leaf, Shield, BadgeDollarSign } from 'lucide-react';
import { commitments } from '../data/mock';

const iconMap = {
  Clock,
  Leaf,
  Shield,
  BadgeDollarSign,
};

const CommitmentsSection = () => {
  return (
    <section id="about" className="py-20 bg-[#111111]">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-[#7BA428]/10 text-[#7BA428] px-4 py-2 rounded-full text-sm font-semibold mb-4 border border-[#7BA428]/20">
            Our Promise
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Why Choose Us?
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            We're committed to providing exceptional service with honesty, reliability, and care for our community.
          </p>
        </div>

        {/* Commitments Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {commitments.map((commitment, index) => {
            const IconComponent = iconMap[commitment.icon];
            return (
              <div
                key={index}
                className="group text-center p-8 rounded-3xl bg-[#141414] border border-[#2A2A2A] hover:border-[#7BA428] hover:bg-[#7BA428] transition-all duration-300 cursor-pointer"
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-[#7BA428] group-hover:bg-black rounded-full flex items-center justify-center mx-auto mb-6 transition-all">
                  {IconComponent && <IconComponent className="w-8 h-8 text-black group-hover:text-[#7BA428] transition-colors" />}
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-white group-hover:text-black mb-3 transition-colors">
                  {commitment.title}
                </h3>
                <p className="text-gray-400 group-hover:text-black/70 transition-colors leading-relaxed">
                  {commitment.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Serving Edmonton Areas Banner */}
        <div className="mt-16 bg-[#7BA428] rounded-3xl p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl md:text-4xl font-bold text-black mb-4">
                Serving Edmonton Areas
              </h3>
              <p className="text-black/80 leading-relaxed text-lg md:text-xl">
                We're a local Edmonton business, and we take pride in keeping our community clean and safe. 
                When possible, we donate usable items to local charities and recycle materials to minimize landfill waste.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { label: 'Items Recycled', value: '70%+' },
                { label: 'Items Donated', value: '500+' },
              ].map((stat, idx) => (
                <div key={idx} className="bg-black/10 rounded-2xl p-6 text-center">
                  <div className="text-3xl md:text-4xl font-bold text-black">{stat.value}</div>
                  <div className="text-black/70 text-base md:text-lg">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommitmentsSection;
